export const queryKeys = {
  PATCH_COMPANY_COMMENT: 'PATCH_COMPANY_COMMENT',
  GET_COMPANY_COMMENTS: 'GET_COMPANY_COMMENTS'
};
